module.exports = __webpack_public_path__ + "img/whole_box4_4.aac57e7d.jpg";